import { dataFetcher } from 'core/services/requestHandler';   

const getRoles = async (data = {}, config = {}, path='') => {
  return dataFetcher('acl/roles'+path, data, {...config});
};

const deleteRole = async (data = {}, config = {}, path) => {
  return dataFetcher('acl/deleteRole'+path, data, {...config});
};

const addRole = async (data = {}, config = {}) => {
  return dataFetcher('acl/addRole', data, {method: 'POST', ...config});
};

const updateRole = async (data = {}, config = {}) => {
  return dataFetcher('acl/updateRole', data, {method: 'POST', ...config});
};

export { getRoles, deleteRole, addRole, updateRole };
